<div class="flex flex-column w-full h-screen min-h-screen">
  <!-- Navigation -->
  <medsurf-navbar class="mb-2"></medsurf-navbar>
  <!-- Content -->
  @if ({
    releases: releaseNoteAuthorFacade.releases$ | async,
    currentRelease: releaseNoteAuthorFacade.currentRelease$(version) | async
  }; as data) {
    <div
      class="flex flex-1 overflow-auto justify-content-center align-self-center w-11 lg:w-7 mb-2">
      <div class="flex flex-column row-gap-2 w-full">
        @for (release of data.releases; track release.name; let latest = $first) {
          <div
            class="surface-100 p-3 border-top-3 border-transparent"
            [class.ml-6]="data.currentRelease !== release"
            [class.border-green-400]="latest"
            [class.border-cyan-400]="data.currentRelease === release"
            [class.opacity-50]="!isActive(data.currentRelease, release)"
            >
            <div class="flex justify-content-between mb-2">
              <div>
                <div class="text-2xl font-bold mb-1">{{ release.tag_name }}</div>
                <div class="mb-2">{{ release.released_at | date_shared }}</div>
              </div>
              <div class="flex gap-1">
                @if (release === data.currentRelease) {
                  <p-tag
                    [value]="'global.current_version' | translate"
                    severity="info"
                  />
                }
                @if (latest) {
                  <p-tag
                    [value]="'global.latest_version' | translate"
                    severity="success"
                  />
                }
                @if (release.commit.short_id !== '_') {
                  <p-tag
                    [value]="release.commit.short_id"
                    severity="info"
                  />
                }
              </div>
            </div>
            <markdown>
              {{release.description}}
            </markdown>
          </div>
        }
      </div>
    </div>
  }
</div>
